import { Flex } from '@aloft/toolkit-sui';

export function FormGroup({ children }: React.PropsWithChildren) {
  return (
    <Flex flexDirection="column" gap="12px">
      {children}
    </Flex>
  );
}
